/**
 * Debug logging configuration
 * API and Railway debug logs only run when explicitly opted in via EXPO_PUBLIC_DEBUG_API.
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

export const isApiDebugEnabled =
  isDevelopment &&
  (process.env.EXPO_PUBLIC_DEBUG_API === 'true' || process.env.EXPO_PUBLIC_DEBUG_API === '1');
